// routes
import Router from './backoffice-app-code/routes';
// theme
// components
import ThemeSettings from './components/settings';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import ThemeProvider from './theme-code/theme';
import NotistackProvider from './backoffice-app-code/components/providers/NotistackProvider';
import { LoginRedirectionListener } from './backoffice-app-code/features/Auth/components/LoginRedirectionListener';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ThemeSettings>
          <NotistackProvider>
            <ProgressBarStyle />
            <ScrollToTop />
            <Router />
            <LoginRedirectionListener />
          </NotistackProvider>
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
